import { message } from 'antd';
import instance from '../instance';
import { handleError } from './errors';

export const EditInitiativeUsher =
  (usherID, initiativeID, data) => async () => {
    try {
      await instance.put(
        `initiatives/${initiativeID}/ushers/${usherID}/`,
        data,
      );
      return 'Success';
    } catch (error) {
      return handleError(error);
    }
  };

export const FetchCalculatedDays = initiativeUsherID => async () => {
  try {
    const response = await instance.get(
      `initiative-ushers/${initiativeUsherID}/calculated-days/`,
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export const editInitiativeUsherBulk = data => async () => {
  try {
    const response = await instance.post(`initiatives/ushers/bulk/`, data);
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export const EditAttendanceHistory = (recordID, data) => async () => {
  try {
    await instance.put(`/attendance-history/${recordID}/`, data);
    return 'Success';
  } catch (error) {
    return handleError(error);
  }
};

export const AddAttendanceHistory = data => async () => {
  try {
    await instance.post(`/attendance-history/`, data);
    return 'Success';
  } catch (error) {
    return handleError(error);
  }
};
export const EditAttendanceHistoryBulk = data => async () => {
  try {
    await instance.put(`/attendance-history/bulk/`, data);
    return 'Success';
  } catch (error) {
    return handleError(error);
  }
};

export const FetchAttendanceHistoryList = async (
  initiativeID,
  searchParams,
) => {
  try {
    const response = await instance.get(
      `/initiative/${initiativeID}/attendance/`,
      {
        params: searchParams,
      },
    );
    return response.data;
  } catch (error) {
    return handleError(error);
  }
};

export const NewCommunicationRecord = data => async dispatch => {
  try {
    await instance.post('/communication-history/add/', data);
  } catch (error) {
    return handleError(error);
  }
};

export const EditCommunicationHistoryRecord =
  (recordID, recordData) => async () => {
    try {
      await instance.put(`/communication-history/${recordID}/`, recordData);
    } catch (error) {
      return handleError(error);
    }
  };

export const DeleteCommunicationHistoryRecord = recordID => async () => {
  try {
    await instance.delete(`/communication-history/${recordID}/`);
  } catch (error) {
    return handleError(error);
  }
};
export const exportAllData = searchParams => async () => {
  try {
    const response = await instance.post(
      '/initiative-ushers/export/all/',
      {},
      {
        params: { ...searchParams, page_size: 1000 },
      },
    );
    message.open({
      type: 'success',
      content: response.data['message'],
      duration: 5,
    });
    return 'Success';
  } catch (error) {
    return handleError(error);
  }
};

export const UpsertInitiativeUshersStep = data => async () => {
  try {
    await instance.post('/initiative-ushers-step/', data);
  } catch (error) {
    return handleError(error);
  }
};

export const AddInitiativeUshersStepResult = data => async () => {
  try {
    await instance.post('/step-results/', data);
  } catch (error) {
    return handleError(error);
  }
};
export const exportIBanUshers = searchParams => async () => {
  const param = new URLSearchParams(searchParams).toString();
  const res = await instance.get(
    'initiatives/ushers/export/civil_id/?' + param,
    {},
  );
  message.open({
    type: 'success',
    content: res.data['message'] || '',
    duration: 5,
  });
  return 'Success';
};
